import { createElement } from 'react'

import { LoaderWrapperDS } from '@src/components/blocks/loader-wrapper-ds'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { Loader } from './Loader'
import { LoaderOverlayWrapper } from './LoaderOverlayWrapper'
import LoaderSVG from './LoaderSVG'
import LoaderWrapperLegacy, { LoaderWrapperProps } from './LoaderWrapper'
import { SmartLoaderWrapper } from './SmartLoaderWrapper'

const REM_IN_PX = 16

// LoaderWrapperDS takes loaderSize in px (number); convert the legacy CSS string ('2rem', '44px')
const toLoaderSizePx = (loaderSize?: string): number | undefined => {
  if (!loaderSize) {
    return undefined
  }
  const value = Number.parseFloat(loaderSize)
  if (Number.isNaN(value)) {
    return undefined
  }
  return loaderSize.trim().endsWith('rem') ? value * REM_IN_PX : value
}

const LoaderWrapper = (props: LoaderWrapperProps) => {
  if (shouldUseDesignSystem()) {
    const { loaderSize, ...dsProps } = props
    return createElement(LoaderWrapperDS, { ...dsProps, loaderSize: toLoaderSizePx(loaderSize) })
  }
  return createElement(LoaderWrapperLegacy, props)
}

export default LoaderWrapper
export { LoaderWrapper, LoaderSVG, Loader, LoaderOverlayWrapper, SmartLoaderWrapper }
export type { LoaderWrapperProps }
